import { IconProps } from "../../../utils/global-types/global-types";

const PMSPropertyManagementIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className || "w-5 h-5 text-primary-blue-dk"}
    {...rest}
  >
    <g
      fill="currentColor"
      fillRule="evenodd"
      clipPath="url(#clip0_1084_155094)"
      clipRule="evenodd"
    >
      <path d="M4.625 5.875a2.19 2.19 0 0 1 2.188-2.187h7.291a2.19 2.19 0 0 1 2.188 2.187v8.75a2.19 2.19 0 0 1-2.188 2.188h-2.56c.245-.424.373-.905.373-1.394v-3.965a2.82 2.82 0 0 0-.855-2.017L8.145 6.585a2.97 2.97 0 0 0-3.52-.454zm8.02.73a.73.73 0 1 1 1.46 0 .73.73 0 0 1-1.46 0m-2.187-.73a.73.73 0 1 0 0 1.458.73.73 0 0 0 0-1.458m2.188 4.375a.73.73 0 1 1 1.459 0 .73.73 0 0 1-1.46 0m.729 2.917a.73.73 0 1 0 0 1.458.73.73 0 0 0 0-1.458"></path>
      <path d="M4.537 7.848a2.19 2.19 0 0 1 3.093 0l2.187 2.188c.41.41.641.966.641 1.547v3.042a2.187 2.187 0 0 1-2.187 2.187H6.812v-2.187a.73.73 0 0 0-1.458 0v2.187H3.896a2.187 2.187 0 0 1-2.188-2.187v-3.043c0-.58.231-1.135.641-1.545z"></path>
    </g>
    <defs>
      <clipPath id="clip0_1084_155094">
        <path fill="#fff" d="M0 0h18v18H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default PMSPropertyManagementIcon;
